'use client';

import { useQuery } from '@tanstack/react-query';

import { UnauthQueryOptions } from '@/api';
import { DEFAULT_LOCATION } from '@/constants/geo';
import { useAuthStore } from '@/stores/AuthStore';

import { formatDistanceLabel } from '../../_utils/formatDistanceLabel';

interface FestivalDistanceProps {
  tourId: string;
}

export const FestivalDistance = ({ tourId }: FestivalDistanceProps) => {
  // 거리 기준 지역 — 선택 지역 → 내 정보 지역 → 기본 지역 순 (홈 피드와 동일)
  const codeSubRegion = useAuthStore(
    ({ region, myInfo }) =>
      region?.at(0)?.codeSubRegion ||
      myInfo?.codeSubRegion ||
      DEFAULT_LOCATION.codeSubRegion,
  );

  const { data } = useQuery(
    UnauthQueryOptions['get:/wello/v2/allows/tour/{tourId}/distance']({
      path: { tourId },
      query: { subRegionCode: codeSubRegion },
    }),
  );

  const distance = data?.context?.distance;

  if (typeof distance !== 'number') return null;

  const distanceLabel = formatDistanceLabel(distance);

  return (
    <span className="flex shrink-0 animate-fade items-center gap-8 animate-duration-300 motion-reduce:animate-none">
      <span aria-hidden="true" className="size-2 rounded-pill bg-Gray-300" />
      <span className="font-600 text-Gray-800">{distanceLabel}</span>
    </span>
  );
};
